import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";
import { disableTwoFactor } from "src/store/account";
import { makeStyles } from "tss-react/mui";

import { Box, Theme, Typography } from "@mui/material";
import { LoadingIcon } from "@shared/Loading";
import { SectionPanel } from "@shared/SectionPanel/SectionPanel";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

const useStyles = makeStyles()((theme: Theme) => ({
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120,
        flexDirection: "column",
        gap: theme.spacing(2),
    },
}));

type TwoFactorDisableFormProps = {
    onSuccess: () => void;
    onCancel: () => void;
};

export const TwoFactorDisableForm = ({ onSuccess, onCancel }: TwoFactorDisableFormProps) => {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    useEffect(() => {
        void (async () => {
            try {
                const { message } = await dispatch(disableTwoFactor()).unwrap();
                showSuccessToast(message);
                onSuccess();
            } catch (err) {
                const error = err as Error;
                showErrorToast(error.message);
                onCancel();
            } finally {
                setLoading(false);
            }
        })();
    }, [dispatch, onCancel, onSuccess]);

    return (
        <SectionPanel title={t("pages:twoFactorDisablePage.metaTitle")}>
            <Box className={classes.loadingBox}>
                {loading ? (
                    <>
                        <LoadingIcon />
                        <Typography variant="body2" color="text.secondary">
                            {t("pages:settingsPage.accountSecurity.twoFactorDisabling")}
                        </Typography>
                    </>
                ) : null}
            </Box>
        </SectionPanel>
    );
};
